import { sendRequest } from 'services/api';

export const ROUTES = {
    GET_ALL_JOBS: {
        path: '/jobs',
        method: 'get',
        isRodx: true,
    },
    GET_JOB: {
        path: '/job',
        method: 'get',
        isRodx: true,
    },
    CREATE_JOB: {
        path: '/job',
        method: 'post',
        isRodx: true,
    },
    UPDATE_JOB: {
        path: '/job',
        method: 'patch',
        isRodx: true,
    },
    DELETE_JOB: {
        path: '/job',
        method: 'delete',
        isRodx: true,
    },
    GET_JOB_COUNT: {
        path: '/job/count',
        method: 'get',
        isRodx: true,
    },
    GET_ALL_LOCATIONS: {
        path: '/locations',
        method: 'get',
        isRodx: true,
    },
    GET_LOCATION: {
        path: '/location',
        method: 'get',
        isRodx: true,
    },
    CREATE_LOCATION: {
        path: '/location',
        method: 'post',
        isRodx: true,
    },
    UPDATE_LOCATION: {
        path: '/location',
        method: 'patch',
        isRodx: true,
    },
    GET_CONNECTED_REPAIRERS: {
        path: '/company/connections',
        method: 'get',
        isRodx: true,
    },
    GET_COMPANY: {
        path: '/company',
        method: 'get',
        isRodx: true,
    },
    UPDATE_COMPANY: {
        path: '/company',
        method: 'patch',
        isRodx: true,
    },
    CREATE_COMPANY_REVIEW: {
        path: '/company',
        method: 'post',
        action: '/review',
        isRodx: true,
    },
    GET_NOTIFICATIONS: {
        path: '/notification',
        method: 'get',
    },
    MARK_NOTIFICATION_AS_READ: {
        path: '/notification/markAsRead',
        method: 'get',
    },
    MARK_NOTIFICATION_AS_READ_BY_MESSAGE_ID: {
        path: '/notification/markAsRead',
        method: 'patch',
    },
    CREATE_NOTIFICATION: {
        path: '/notification/create',
        method: 'post',
    },
    LOGIN: {
        path: '/login',
        method: 'post',
    },
    REFRESH_TOKEN: {
        path: '/refresh-token',
        method: 'post',
    },
    FORGOT_PASSWORD: {
        path: '/forgot-password',
        method: 'post',
    },
    GET_INVOICES: {
        path: '/invoices',
        method: 'get',
        isRodx: true,
    },
    SERVICE_ATTACH_MEDIA: {
        path: '/service',
        method: 'post',
        action: '/attach-media',
        isRodx: true,
    },
    SERVICE_CANCEL: {
        path: '/service',
        method: 'post',
        action: '/cancel',
        isRodx: true,
    },
    SERVICE_ACCEPT_SUPPLEMENT: {
        path: '/service',
        method: 'post',
        action: '/accept-supplement',
        isRodx: true,
    },
    SERVICE_REJECT_SUPPLEMENT: {
        path: '/service',
        method: 'post',
        action: '/reject-supplement',
        isRodx: true,
    },
    SERVICE_DECLINE: {
        path: '/service',
        method: 'post',
        action: '/decline',
        isRodx: true,
    },
    SERVICE_ACCEPT: {
        path: '/service',
        method: 'post',
        action: '/accept',
        isRodx: true,
    },
    SERVICE_SUPPLEMENT: {
        path: '/service',
        method: 'post',
        action: '/supplement',
        isRodx: true,
    },
    SERVICE_START: {
        path: '/service',
        method: 'post',
        action: '/start',
        isRodx: true,
    },
    SERVICE_COMPLETE: {
        path: '/service',
        method: 'post',
        action: '/complete',
        isRodx: true,
    },
    SERVICE_REQUEST_REWORK: {
        path: '/service',
        method: 'post',
        action: '/request-rework',
        isRodx: true,
    },
    SERVICE_SUBLET: {
        path: '/service',
        method: 'post',
        action: '/sublet',
        isRodx: true,
    },
    SERVICE_UPDATE: {
        path: '/service',
        method: 'patch',
        action: '',
        isRodx: true,
    },
    JOB_UPDATE_DETAILS: {
        path: '/job',
        method: 'patch',
        action: '/details',
        isRodx: true,
    },
    GET_USERS: {
        path: '/users',
        method: 'get',
    },
    GET_ENUMS: {
        path: '/enums',
        method: 'get',
        isRodx: true,
    },
    GET_CATALOG: {
        path: '/catalog',
        method: 'get',
        isRodx: true,
    },
    GET_CATALOG_VERSION: {
        path: '/catalog/version',
        method: 'get',
        isRodx: true,
    },
    SUBSCRIBE: {
        path: '/push/subscribe',
        method: 'post',
    },
    UNSUBSCRIBE: {
        path: '/push/unsubscribe',
        method: 'post',
    },
    GET_ESTIMATE: {
        path: '/estimate',
        method: 'post',
        isRodx: true,
    },
    GET_SENDBIRD_AUTH: {
        path: '/chat/user/access',
        method: 'get',
        isRodx: true,
    },
};

export const SERVICES = [
    {
        id: 1,
        name: 'Bodywork',
    },
    {
        id: 2,
        name: 'Calibration',
    },
    {
        id: 3,
        name: 'De-Identification',
    },
    {
        id: 4,
        name: 'Detail',
    },
    {
        id: 5,
        name: 'Diagnostic',
    },
    {
        id: 6,
        name: 'Glass Repair',
    },
    {
        id: 7,
        name: 'Glass Replacement',
    },
    {
        id: 8,
        name: 'Inspection',
    },
    {
        id: 9,
        name: 'Interior Repair',
    },
    {
        id: 10,
        name: 'Key Replacement',
    },
    {
        id: 11,
        name: 'Mechanical',
    },
    {
        id: 12,
        name: 'Paint',
    },
    {
        id: 13,
        name: 'PDR',
    },
    {
        id: 14,
        name: 'PII Removal',
    },
    {
        id: 15,
        name: 'PPF',
    },
    {
        id: 16,
        name: 'Remove and Install',
    },
    {
        id: 17,
        name: 'Remove and Replace',
    },
    {
        id: 18,
        name: 'Rim Repair',
    },
    {
        id: 19,
        name: 'Tint',
    },
    {
        id: 20,
        name: 'Vinyl Wrap',
    },
];

export const STATUSES = [
    {
        id: 0,
        name: 'OPEN',
        status: 'open',
    },
    {
        id: 1,
        name: 'ACCEPTED',
        status: 'accepted',
    },
    {
        id: 2,
        name: 'PENDING_APPROVAL',
        status: 'pending approval',
    },
    {
        id: 3,
        name: 'DECLINED',
        status: 'declined',
    },
    {
        id: 4,
        name: 'IN_PROGRESS',
        status: 'in progress',
    },
    {
        id: 5,
        name: 'COMPLETED',
        status: 'completed',
    },
    {
        id: 6,
        name: 'INVOICED',
        status: 'invoiced',
    },
    {
        id: 7,
        name: 'CLOSED',
        status: 'closed',
    },
    {
        id: 8,
        name: 'CANCELED',
        status: 'canceled',
    },
];

export const STATUS_BAR_CLASS = {
    'Open': 'OPEN',
    'Accepted': 'ACCEPTED',
    'In Progress': 'IN_PROGRESS',
    'Completed': 'COMPLETED',
    'Closed': 'CLOSED',
    'Declined': 'DECLINED',
    'Canceled': 'CANCELED',
};

export const STATUS_BAR_DISPLAY = {
    'Open': 'Open',
    'Accepted': 'Accepted',
    'In Progress': 'In Progress',
    'Completed': 'Completed',
    'Closed': 'Closed',
    'Declined': 'Declined',
    'Canceled': 'Canceled',
};

export const getColors = async function() {
    const result = [
        'Beige',
        'Black',
        'Blue',
        'Brown',
        'Gold',
        'Gray',
        'Green',
        'Orange',
        'Purple',
        'Red',
        'Silver',
        'White',
        'Yellow',
    ];
    return result;
};

// TODO: move these
export const gatherStaticData = async function() {
    return sendRequest(ROUTES.GET_ENUMS);
};

export const gatherCatalog = async function() {
    return sendRequest(ROUTES.GET_CATALOG);
};

export const getCatalogVersion = async function() {
    return sendRequest(ROUTES.GET_CATALOG_VERSION);
};
